import handler from '../handler/handler';
import messages from '../handler/messages/messages';

const statusHandler = handler(messages);

export default {
  state: {
    supplierList: null,
  },
  getters: {
    getSupplierList: state => state.warehouseList,
  },
  mutations: {
    successSupplier: (state, payload) => {
      state.warehouseList = payload;
    },
  },
  actions: {
    updateSupplier: async ({ commit, getters }, supplier) => {
      const query = {
        id: supplier.id,
        name: supplier.name,
        prepare_days: supplier.prepareDays,
      };

      const result = await statusHandler.authPut({ commit, getters }, `/api/suppliers/${supplier.id}`, query);
      return result;
    },

    createEmptySupplier: async ({ commit, getters }) => {
      const result = await statusHandler.authPost({ commit, getters }, '/api/suppliers');
      return result;
    },

    // 공급자 삭제는 논의 이후 구현

    // deleteSupplier: async ({ commit, getters }, id) => {
    //   const result = await statusHandler.authDelete({ commit, getters }, `/api/suppliers/${id}`);
    //   return result;
    // },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/supplier.js